import React, { useEffect, useState, useMemo } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Table, Form } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import ExportToExcel from "../../../../components/ExportToExcel";
import { Accordion, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomDatePicker from "../../../../components/Custom-Datepicker";

const InvoiceReportTraining = (data) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Invoice Report (Training)"));
  }, []);

  const [resource, setResource] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [emp, setEmp] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const [activeClientKeys, setActiveClientKeys] = useState([]);
  const [activeProjectKeys, setActiveProjectKeys] = useState({});
  const [isInitialized, setIsInitialized] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({
    InvoiceDate: true,
    InvoiceNo: true,
    EmployeeName: true,
    InvoiceRateFreq: true,
    DayCount: true,
    WorkingDays: true,
    BasicAmount: true,
    InvoicedDays: true,
    AdjustmentAmount: true,
    TaxPercent: true,
    ExchangeRate: true,
    InvoicedAmount: true,
    InvoiceCalculatedAmount: true,
    PaymentTermDays: true,
    PaymentDueDate: true,
    FollowUpDate: true,
    PaymentReceivedDate: true,
    OverDueDays: true,
    FixedBid: true,
    Consolidated: true,
    Remarks: true,
  });
  const columns = [
    {
      id: "InvoiceDate",
      label: "Invoice Date",
      accessor: "InvoiceDate",
      format: (val) => moment(val).format("DD-MM-YYYY"),
    },
    { id: "InvoiceNo", label: "Invoice", accessor: "InvoiceNo" },
    { id: "EmployeeName", label: "Emp. Name", accessor: "EmployeeName" },
    { id: "InvoiceRateFreq", label: "Rate/Freq", accessor: "InvoiceRateFreq" },
    { id: "DayCount", label: "Day Count", accessor: "DayCount" },
    {
      id: "WorkingDays",
      label: "Client Working Days",
      accessor: "WorkingDays",
    },
    { id: "BasicAmount", label: "Basic Amt", accessor: "BasicAmount" },
    { id: "InvoicedDays", label: "Inv. Days", accessor: "InvoicedDays" },
    {
      id: "AdjustmentAmount",
      label: "Adjustment Amt",
      accessor: "AdjustmentAmount",
    },
    { id: "TaxPercent", label: "Tax %", accessor: "TaxPercent" },
    { id: "ExchangeRate", label: "Exchange Rate", accessor: "ExchangeRate" },
    { id: "InvoicedAmount", label: "Profarma Amt", accessor: "InvoicedAmount" },
    {
      id: "InvoiceCalculatedAmount",
      label: "Invoice Amt",
      accessor: "InvoiceCalculatedAmount",
    },
    {
      id: "PaymentTermDays",
      label: "Pymt. Term Day",
      accessor: "PaymentTermDays",
    },
    {
      id: "PaymentDueDate",
      label: "Pymt.Due Date",
      accessor: "PaymentDueDate",
    },
    { id: "FollowUpDate", label: "Follow-up Date", accessor: "FollowUpDate" },
    {
      id: "PaymentReceivedDate",
      label: "Pymt.Recd Date",
      accessor: "PaymentReceivedDate",
    },
    { id: "OverDueDays", label: "OverDue", accessor: "OverDueDays" },
    { id: "FixedBid", label: "Fixed Bid", accessor: "FixedBid" },
    { id: "Consolidated", label: "Consolidated", accessor: "Consolidated" },
    { id: "Remarks", label: "Remarks", accessor: "Remarks" },
  ];

  const toggleColumnVisibility = (columnId) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };
  const filters = {
    Employee: 0,
  };
  const [filter, setFilter] = useState(filters);
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    Overdue: 0,
  });

  useEffect(() => {
    fetchResourceReport();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchResourceReport = async (clientId, projectId) => {
    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/project-training-invoice-report?P_FromDate&P_ToDate&P_OverDueDays`
      );
      if (response?.status === 200) {
        setResource(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching resource report:", error);
    } finally {
      setLoading(false); // Hide spinner when done (success or error)
    }
  };

  // Filter data based on search term
  const filteredData = useMemo(() => {
    return resource.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [resource, searchTerm]);

  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Get current items for pagination
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    return filteredData.slice(startIndex, endIndex);
  };

  const currentItems = getCurrentItems();

  // Create nested structure for display from the current paginated items
  const nestedData = useMemo(() => {
    return currentItems.reduce((acc, item) => {
      if (!acc[item.ClientName]) {
        acc[item.ClientName] = {};
      }
      if (!acc[item.ClientName][item.ProjectName]) {
        acc[item.ClientName][item.ProjectName] = [];
      }
      acc[item.ClientName][item.ProjectName].push(item);
      return acc;
    }, {});
  }, [currentItems]);


  
 useEffect(() => {
    if (!loading && Object.keys(nestedData).length > 0 && !isInitialized) {
      const allClientKeys = Object.keys(nestedData).map((_, i) => i.toString());
      setActiveClientKeys(allClientKeys);

      const allProjectKeys = {};
      Object.entries(nestedData).forEach(([_, projects], clientIndex) => {
        allProjectKeys[clientIndex.toString()] = Object.keys(projects).map((_, i) => i.toString());
      });

      setActiveProjectKeys(allProjectKeys);
      setIsInitialized(true);
    }
  }, [nestedData, loading, isInitialized]);
  // Accordion handlers
  const handleClientToggle = (clientKey) => {
    setActiveClientKeys((prev) =>
      prev.includes(clientKey)
        ? prev.filter((key) => key !== clientKey)
        : [...prev, clientKey]
    );
  };


  const handleProjectToggle = (clientKey, projectKey) => {
    console.log("clientKey, projectKey",clientKey, projectKey);
    
    setActiveProjectKeys((prev) => {
      const openProjects = prev[clientKey] || [];
      const isOpen = openProjects.includes(projectKey);

      return {
        ...prev,
        [clientKey]: isOpen
          ? openProjects.filter((k) => k !== projectKey)
          : [...openProjects, projectKey],
      };
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };

  const handleGetData = async () => {
    const { fromDate, toDate, Overdue } = formData;
    setLoading(true);
    // Format dates only if they exist
    const formattedFromDate = fromDate
      ? moment(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? moment(toDate).format("YYYY-MM-DD") : "";

    const url = `${API_URL}projectmanagement/project-training-invoice-report?P_FromDate=${formattedFromDate}&P_ToDate=${formattedToDate}&P_OverDueDays=${
      Overdue || ""
    }`;

    try {
      const response = await GetServiceCaller(url);
      if (response?.status === 200) {
        setResource(response?.data?.data || []);
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };
  const customIndicator = {
    display: "inline-block",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    marginBottom: "0px",
    verticalAlign: "middle",
    marginLeft: "10px",
    marginRight: "3px",
    boxShadow:
      "0 2px 9px 0 rgba(0, 0, 0, 0.18), 0 2px 7px 0 rgba(0, 0, 0, 0.15)",
    border: "solid 2px #fff",
  };

  const InvoiceExportData = (data, columnVisibility, columns) => {
    // Create nested structure
    const nestedData = data.reduce((acc, item) => {
      if (!acc[item.ClientName]) acc[item.ClientName] = {};
      if (!acc[item.ClientName][item.ProjectName]) {
        acc[item.ClientName][item.ProjectName] = [];
      }
      acc[item.ClientName][item.ProjectName].push(item);
      return acc;
    }, {});

    // Get visible columns
    const visibleColumns = columns.filter((col) => columnVisibility[col.id]);

    // Prepare the export data
    const exportData = [];
    // Add data rows with hierarchy
    Object.entries(nestedData).forEach(([clientName, projects]) => {
      // Add client row
      const clientRow = {};
      visibleColumns.forEach((col, index) => {
        clientRow[col.label] = index === 0 ? `Client: ${clientName}` : "";
      });
      exportData.push(clientRow);

      Object.entries(projects).forEach(([projectName, items]) => {
        // Add project row
        const projectRow = {};
        visibleColumns.forEach((col, index) => {
          projectRow[col.label] =
            index === 0
              ? `Project: ${projectName} (SOW/PO/SO ${
                  items[0]?.ProjectInvoiceDetailNumber || "N/A"
                })`
              : "";
        });
        exportData.push(projectRow);

        // Add item rows
        items.forEach((item) => {
          const row = {};
          visibleColumns.forEach((col) => {
            if (
              [
                "InvoiceDate",
                "PaymentDueDate",
                "FollowUpDate",
                "PaymentReceivedDate",
              ].includes(col.id)
            ) {
              row[col.label] = moment(item[col.accessor]).format("DD-MMM-YYYY");
            } else {
              row[col.label] = item[col.accessor] || "";
            }
          });
          exportData.push(row);
        });
      });
    });

    return exportData;
  };
  return (
    <>
      <div className="invoice-report-training">
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="table-responsive">
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <div className="me-1">
                    <SearchBar
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}
                  >
                    <div className="btn-group me-2">
                      <button
                        type="button"
                        className="dropdown-toggle skill-button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={() => setShowDropdown(!showDropdown)}
                        id="excel-btn"
                      >
                        <i className="bi bi-funnel-fill"></i>
                      </button>
                      <ul
                        className={`dropdown-menu p-2 project-status-filter ${
                          showDropdown ? "show" : ""
                        }`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <label className="form-label">From Date</label>
                            <CustomDatePicker
                              name="fromDate"
                              className="form-control"
                              placeholderText="DD-MMM-YYYY"
                              handleChange={(e) => handleChange(e)}
                              value={formData.fromDate}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">To Date</label>
                            <CustomDatePicker
                              name="toDate"
                              className="form-control"
                              placeholderText="DD-MMM-YYYY"
                              handleChange={(e) => handleChange(e)}
                              value={formData.toDate}
                            />
                          </div>
                          <div className="col-sm-3 mt-4">
                            <label
                              htmlFor="flexSwitchCheckChecked"
                              className="form-label me-2"
                            >
                              Overdue
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="Overdue"
                              id="flexSwitchCheckChecked"
                              checked={formData.Overdue === 1}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="text-end">
                            <button
                              className="custom-btn mx-2"
                              onClick={() => {
                                setFormData({
                                  fromDate: "",
                                  toDate: "",
                                  Overdue: 0,
                                });
                                setShowDropdown(false);
                                fetchResourceReport();
                              }}
                            >
                              Reset
                            </button>
                            <button
                              className="custom-btn"
                              onClick={() => {
                                handleGetData();
                                setShowDropdown(false);
                              }}
                            >
                              Get Data
                            </button>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </OverlayTrigger>
                </div>
                <div className="d-flex justify-content-end">
                  <div className="me-1">
                    <ExportToExcel
                      data={InvoiceExportData(
                        resource,
                        columnVisibility,
                        columns
                      )}
                      filename="Invoice Report (Training).csv"
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="me-1">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-top">Column Chooser</Tooltip>
                        }
                      >
                        <div className="btn-group me-2">
                          <button
                            type="button"
                            className="dropdown-toggle skill-button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            id="excel-btn"
                          >
                            <i className="bi bi-list"></i>
                          </button>
                          <ul
                            className="dropdown-menu p-2"
                            style={{
                              width: "200px", // Increased width
                              // maxHeight: '500px',  // Added max height with scroll
                              // overflowY: 'auto'  // Enable vertical scrolling if needed
                            }}
                          >
                            <div className="row">
                              <Form.Group style={{ width: "100%" }}>
                                {columns.map((column) => (
                                  <div
                                    key={column.id}
                                    className="mb-2"
                                    style={{
                                      whiteSpace: "normal", // Enable word wrap
                                      wordBreak: "break-word", // Break long words if needed
                                    }}
                                  >
                                    <Form.Check
                                      type="checkbox"
                                      id={`checkbox-${column.id}`}
                                      label={column.label}
                                      checked={columnVisibility[column.id]}
                                      onChange={() =>
                                        toggleColumnVisibility(column.id)
                                      }
                                    />
                                  </div>
                                ))}
                              </Form.Group>
                            </div>
                          </ul>
                        </div>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-1 d-flex align-items-center">
                <p style={{ ...customIndicator, background: "#bad893" }}></p>
                <span className="me-3">FixedBid</span>
                <p style={{ ...customIndicator, background: "#ffe4a4" }}></p>
                <span>Consolidated</span>
              </div>
              <div
                style={{
                  overflowX: "auto",
                  width: "100%",
                  marginBottom: "10px",
                }}
                className="InvoiceScrollBar"
              >
                <Table
                  bordered
                  style={{ tableLayout: "fixed", minWidth: "2000px" }}
                >
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <th style={{ width: "50px" }}>##</th>
                      {columnVisibility.InvoiceDate && (
                        <th
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Inv Date
                        </th>
                      )}

                      {columnVisibility.InvoiceNo && (
                        <th style={{ width: "120px" }}>Invoice</th>
                      )}
                      {columnVisibility.EmployeeName && (
                        <th style={{ width: "150px" }}>Emp. Name</th>
                      )}
                      {columnVisibility.InvoiceRateFreq && (
                        <th style={{ width: "100px" }}>Rate/Freq</th>
                      )}
                      {columnVisibility.DayCount && (
                        <th style={{ width: "80px" }}>Day Count</th>
                      )}
                      {columnVisibility.WorkingDays && (
                        <th style={{ width: "150px" }}>Client Working Days</th>
                      )}
                      {columnVisibility.BasicAmount && (
                        <th style={{ width: "100px" }}>Basic Amt</th>
                      )}
                      {columnVisibility.InvoicedDays && (
                        <th style={{ width: "100px" }}>Inv. Days</th>
                      )}
                      {columnVisibility.AdjustmentAmount && (
                        <th style={{ width: "120px" }}>Adjustment Amt</th>
                      )}
                      {columnVisibility.InvoicedAmount && (
                        <th style={{ width: "120px" }}>Profarma Amt</th>
                      )}
                      {columnVisibility.TaxPercent && (
                        <th style={{ width: "80px" }}>Tax %</th>
                      )}
                      {columnVisibility.ExchangeRate && (
                        <th style={{ width: "120px" }}>Exchange Rate</th>
                      )}
                      {columnVisibility.InvoiceCalculatedAmount && (
                        <th style={{ width: "120px" }}>Invoice Amt</th>
                      )}
                      {columnVisibility.PaymentTermDays && (
                        <th style={{ width: "120px" }}>Pymt Term Day</th>
                      )}
                      {columnVisibility.PaymentDueDate && (
                        <th style={{ width: "120px" }}>Pymt Due Date</th>
                      )}
                      {columnVisibility.FollowUpDate && (
                        <th style={{ width: "120px" }}>Follow-up Date</th>
                      )}
                      {columnVisibility.PaymentReceivedDate && (
                        <th style={{ width: "120px" }}>Pymt Recd Date</th>
                      )}
                      {columnVisibility.OverDueDays && (
                        <th style={{ width: "80px" }}>Overdue</th>
                      )}
                      {columnVisibility.FixedBid && (
                        <th style={{ width: "80px" }}>Fixed Bid</th>
                      )}
                      {columnVisibility.Consolidated && (
                        <th style={{ width: "100px" }}>Consolidated</th>
                      )}
                      {columnVisibility.Remarks && (
                        <th style={{ width: "200px" }}>Remark</th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={22} className="text-center py-4">
                          <div className="d-flex justify-content-center">
                            <FaSpinner class="spinner" />
                          </div>
                          <div className="text-muted mt-2">Loading</div>
                        </td>
                      </tr>
                    ) : Object.keys(nestedData).length === 0 ? (
                      <tr>
                        <td
                          colSpan={22}
                          className="text-center text-muted py-3"
                        >
                          No Record Found
                        </td>
                      </tr>
                    ) : (
                      Object.entries(nestedData).map(
                        ([clientName, projects], clientIndex) => {
                          const clientKey = clientIndex.toString();
                          return (
                            <tr key={clientKey}>
                              <td
                                colSpan={22}
                                className="p-0"
                              >
                                <Accordion  activeKey={activeClientKeys} style={{ border: "none" }}>
                                  <Accordion.Item eventKey={clientKey}>
                                    <Accordion.Header
                                      onClick={() =>
                                        handleClientToggle(clientKey)
                                      }
                                      className="AccordioninvoiceClient_header"
                                    >
                                      <span className="me-2 accordion_icon">
                                        <FontAwesomeIcon
                                          icon={activeClientKeys === clientKey ? faMinus : faPlus} 
                                        />
                                      </span>
                                      <div className="flex-grow-1 text-black fw-bold">
                                        {clientName}
                                      </div>
                              
                                    </Accordion.Header>

                                    <Accordion.Body className="no-padding">
                                      <Accordion
                                       activeKey={activeProjectKeys[clientKey] || []}
                                      >
                                        {Object.entries(projects).map(
                                          (
                                            [projectName, items],
                                            projectIndex
                                          ) => {
                                            const projectKey =
                                              projectIndex.toString();
                                            return (
                                              <Accordion.Item
                                                eventKey={projectKey}
                                                key={projectKey}
                                              >
                                                <Accordion.Header
                                                  onClick={() =>
                                                    handleProjectToggle(
                                                      clientKey,
                                                      projectKey
                                                    )
                                                  }
                                                  className="AccordioninvoiceProject_header"
                                                >
                                                                      <span className="me-2 accordion_icon">
                                                    <FontAwesomeIcon
                                                      icon={
    activeProjectKeys[clientKey] === projectKey ? faMinus : faPlus
  }
                                                    />
                                                  </span>
                                                  <div className="flex-grow-1 px-8 text-dark">
                                                    {projectName}
                                                    <span className="text-muted">
                                                      {" "}
                                                      (SOW/PO/SO{" "}
                                                      {items[0]
                                                        ?.ProjectInvoiceDetailNumber ||
                                                        "N/A"}
                                                      )
                                                    </span>
                                                  </div>
                                                </Accordion.Header>

                                                <Accordion.Body className="no-padding">
                                                  <Table
                                                    bordered
                                                    // striped
                                                    // hover
                                                    style={{
                                                      tableLayout: "fixed",
                                                      minWidth: "2000px",
                                                    }}
                                                  >
                                                    <tbody>
                                                      {items.map(
                                                        (data, subIndex) => (
                                                          <tr
                                                            key={subIndex}
                                                            className="border"
                                                          >
                                                            <td
                                                              style={{
                                                                width: "50px",
                                                              }}
                                                            ></td>
                                                            {columnVisibility.InvoiceDate && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {data.InvoiceDate ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {moment(
                                                                          data.InvoiceDate
                                                                        ).format(
                                                                          "DD-MMM-YYYY"
                                                                        )}
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {moment(
                                                                        data.InvoiceDate
                                                                      ).format(
                                                                        "DD-MMM-YYYY"
                                                                      )}
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.InvoiceNo && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {data.InvoiceNo ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.InvoiceNo
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.InvoiceNo
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.EmployeeName && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "150px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {data.EmployeeName ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.EmployeeName
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.EmployeeName
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.InvoiceRateFreq && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {data.InvoiceRateFreq ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.InvoiceRateFreq
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.InvoiceRateFreq
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.DayCount && (
                                                              <td
                                                                style={{
                                                                  width: "80px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.DayCount ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.DayCount
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.DayCount
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.WorkingDays && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "150px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.WorkingDays ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.WorkingDays
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.WorkingDays
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  "0"
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.BasicAmount && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "end",
                                                                }}
                                                              >
                                                                {data.BasicAmount ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.BasicAmount
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.BasicAmount
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.InvoicedDays && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.InvoicedDays ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.InvoicedDays
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.InvoicedDays
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.AdjustmentAmount && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "end",
                                                                }}
                                                              >
                                                                {data.AdjustmentAmount ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.AdjustmentAmount
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.AdjustmentAmount
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.InvoicedAmount && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "end",
                                                                }}
                                                              >
                                                                {data.InvoicedAmount ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.InvoicedAmount
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.InvoicedAmount
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.TaxPercent && (
                                                              <td
                                                                style={{
                                                                  width: "80px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "end",
                                                                }}
                                                              >
                                                                {data.TaxPercent ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.TaxPercent
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.TaxPercent
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.ExchangeRate && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "end",
                                                                }}
                                                              >
                                                                {data.ExchangeRate ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.ExchangeRate
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.ExchangeRate
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.InvoiceCalculatedAmount && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "end",
                                                                }}
                                                              >
                                                                {data.InvoiceCalculatedAmount ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.InvoiceCalculatedAmount
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.InvoiceCalculatedAmount
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.PaymentTermDays && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.PaymentTermDays ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.PaymentTermDays
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.PaymentTermDays
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.PaymentDueDate && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.PaymentDueDate ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {moment(
                                                                          data.PaymentDueDate
                                                                        ).format(
                                                                          "DD-MMM-YYYY"
                                                                        )}
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {moment(
                                                                        data.PaymentDueDate
                                                                      ).format(
                                                                        "DD-MMM-YYYY"
                                                                      )}
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.FollowUpDate && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.FollowUpDate ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {moment(
                                                                          data.FollowUpDate
                                                                        ).format(
                                                                          "DD-MMM-YYYY"
                                                                        )}
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {moment(
                                                                        data.FollowUpDate
                                                                      ).format(
                                                                        "DD-MMM-YYYY"
                                                                      )}
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.PaymentReceivedDate && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "120px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.PaymentReceivedDate ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {moment(
                                                                          data.PaymentReceivedDate
                                                                        ).format(
                                                                          "DD-MMM-YYYY"
                                                                        )}
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {moment(
                                                                        data.PaymentReceivedDate
                                                                      ).format(
                                                                        "DD-MMM-YYYY"
                                                                      )}
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.OverDueDays && (
                                                              <td
                                                                style={{
                                                                  width: "80px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {data.OverDueDays ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.OverDueDays
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.OverDueDays
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.FixedBid && (
                                                              <td
                                                                style={{
                                                                  width: "80px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {data.FixedBid ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.FixedBid
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.FixedBid
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.Consolidated && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {data.Consolidated ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.Consolidated
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.Consolidated
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                            {columnVisibility.Remarks && (
                                                              <td
                                                                style={{
                                                                  width:
                                                                    "200px",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {data.Remarks ? (
                                                                  <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                      <Tooltip id="tooltip-top">
                                                                        {
                                                                          data.Remarks
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <span>
                                                                      {
                                                                        data.Remarks
                                                                      }
                                                                    </span>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </td>
                                                            )}
                                                          </tr>
                                                        )
                                                      )}
                                                    </tbody>
                                                  </Table>
                                                </Accordion.Body>
                                              </Accordion.Item>
                                            );
                                          }
                                        )}
                                      </Accordion>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </td>
                            </tr>
                          );
                        }
                      )
                    )}
                  </tbody>
                </Table>
              </div>

           <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-3">
              <div className="d-flex justify-content-between px-2">
                  <span className="d-flex align-items-center">
                    Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                    {Math.min(currentPage * itemsPerPage, filteredData.length)}{" "}
                    of {filteredData.length}{" "}
                    <span className="ms-1">results</span>
                    <select
                      value={itemsPerPage}
                      onChange={(e) => {
                        const newItemsPerPage = Number(e.target.value);
                        setItemsPerPage(newItemsPerPage);
                        setCurrentPage(1); // Reset to first page when changing items per page
                      }}
                      className="mx-2 form-select-sm"
                    >
                      {recordsPerPageOption.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
                 <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
                  <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceReportTraining;
